export default "__VITE_ASSET__C4kLp9gv__"